module.exports = __webpack_public_path__ + "img/bg.45526412.jpg";